<template>
  <div class="main-container">
    <RecruitNav/>
    <div class="favorite-company-container">
      <div class="title-container">
        <h1>フォロー中の企業</h1>
      </div>
      <div class="favorite-novel-container">
        <article v-for="(followData, i) in followDatas" :key=i  class="favorite-company-wrapper">
          <section class="company-info">
            <h3 class="company-name">{{followData.company_name}}</h3>
          </section>
          <section>
            <p style="font-size: 14px; margin-bottom: 8px;">最新のノベル</p>
            <div class="novel-info">
              <div v-if="followData.story_existence">
                <a :href="'/recruits/story/' + followData.company_id + '/' + followData.story_id">
                  <div class="novel-img-wrapper">
                    <img :src="getBackgroundScene(followData.story_icon_url ,followData.story_icon_type)" alt="">
                  </div>
                  <div class="novel-info-container">
                    <p class="novel-title"><font-awesome-icon :icon="['fas', 'book-reader']" />{{followData.story_name}}</p>
                    <div class="novel-description">{{followData.story_description}}</div>
                  </div>
                </a>
              </div>
              <div class="novel-noen-msg-wrapper" v-if="!followData.story_existence">
                <p class="novel-noen-msg">ノベルはまだ投稿されていません</p>
              </div>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/layouts/Header'
import RecruitNav from '@/views/Recruit/RecruitNav'
import { mapState } from 'vuex'

export default {
  name: 'FollowCompany',
  componentName: 'FollowCompany',
  components: {
    RecruitNav
  },
  computed: {
    ...mapState('auth', ['followDatas'])
  },
  mounted() {
    this.getFollowInfo()
  },
  methods: {
    getFollowInfo() {
      this.$store.dispatch('auth/getFollowInfo')
    },
    getBackgroundScene (icon_url, icon_type) {
      // 自分で登録した画像があるとき
      if (icon_url) {
        return icon_url
      } else {
        // デフォルト画像から使う
        return require('@/assets/scene/' + icon_type + '.jpg')
      }
    },
  }
}
</script>

<style scoped lang="scss">
  .title-container {
    h1 {
      font-size: 24px;
      font-weight: bold;
    }
  }
  .favorite-company-container {
    width: 90%;
    margin: auto;
    text-align: left;
    padding: 40px 0;
  }

  .favorite-novel-container {
    height: calc(100vh - 156px);
    overflow: auto;
  }
  .favorite-novel-container::-webkit-scrollbar {
    width:  10px !important;
    height: 10px !important;
    visibility: visible !important;
  }
  .favorite-company-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    margin: auto;
    margin-top: 24px;
    margin-bottom: 24px;
    box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.31);
    padding: 16px;
  }
  .company-name {
    font-size: 16px;
    font-weight: bold;
    color: #C82E42;
    margin-right: 16px;
    word-wrap: break-word;
  }
  .company-info, .novel-info {
    width: 320px;
  }
  .novel-info {
    padding: 16px;
    box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.31);
  }
  .novel-img-wrapper {
    img {
      width: 100%;
      height: 136px;
      object-fit: cover;
      vertical-align: bottom;
    }
  }
  .novel-title {
    color: #4a4a4a;
    font-weight: bold;
    font-size: 14px;
    margin-top: 8px;
    word-wrap: break-word;
    svg {
      color: #C82E42;
    }
  }
  .novel-noen-msg {
    color:#9e9e9e;
    font-size: 14px;
  }
  .novel-description {
    font-size: 12px;
    color: #4a4a4a;
    word-wrap: break-word;
    margin-top: 8px;
  }

@media screen and (max-width: 896px) {
  .company-name {
    margin-bottom: 16px;
  }
  .favorite-company-wrapper {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Recruit/FollowCompany.vue